function disableQikifyAutocomplete() {
  document.querySelectorAll(
    '.qikify-product-options input[type="text"], .qikify-product-options textarea'
  ).forEach(function(el) {
    el.setAttribute('autocomplete', 'off');
  });
}

// Ejecutar al cargar y cuando Qikify renderice dinámicamente los campos
document.addEventListener('DOMContentLoaded', disableQikifyAutocomplete);

// Por si Qikify tarda en cargar (app embed asíncrono)
setTimeout(disableQikifyAutocomplete, 1500);
setTimeout(disableQikifyAutocomplete, 3000);
